export default "__VITE_ASSET__DZ7yJxfw__"